module.exports = __webpack_public_path__ + "media/images/logo-home-82b0e40d7be58c44f3308708b7f94a0f.png";